// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"308":"3e51ba2f","361":"bdfcc9e3","904":"a9ef11f4","939":"534ccba6"}[chunkId] + ".chunk.css";
};